import { Injectable } from '@angular/core';
import {
  Authors,
  Categories,
  Feedback,
  Likes,
  Status
} from '../models/feedback';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpContext } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { HttpContextConfig } from '../models/http-context-config';
import { CONFIG } from '../interceptors/loader.interceptor';

const commentURL = `${environment.api}/comments/`;

const config = new HttpContextConfig();
config.noSpinner = true;

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {
  constructor(private http: HttpClient) {}

  url = `${environment.api}/feedbacks/`;
  categoryURL = `${environment.api}/feedbackcategories/`;

  getFeedback(body: any): Observable<any> {
    return of({ result: [] });
  }

  getFeedback360(body: any): Observable<any> {
    return of({ result: null });
  }

  storeCommentFeedback360(body: any): Observable<any> {
    return of({ result: null });
  }

  reviewF360StoreGoals(body: any): Observable<any> {
    return of({ result: null });
  }

  getFeedbackByAlias(filter_search?: any): Observable<any> {
    return of({ result: [] });
  }

  getAuthors(body?: any): Observable<Authors> {
    return of({ result: [] } as unknown as Authors);
  }

  getCategories(body?: any): Observable<any> {
    return of({ result: [] });
  }

  getStatus(body?: any): Observable<any> {
    return of({ result: [] });
  }

  toggleLike(id: number, user_id: string): Observable<Likes> {
    return of({} as Likes);
  }

  addFeedback(feedback: Feedback): Observable<Feedback> {
    return of(feedback);
  }

  updateFeedback(id: number, feedback: any): Observable<any> {
    return of({ result: feedback });
  }

  deleteFeedback(id: number): Observable<Feedback> {
    return of({} as Feedback);
  }

  getOneCategory(alias: string) {
    return of({ result: null });
  }

  /* COMMENTI */

  /**
   *
   * @param newComment  description: il contenuto del commento,
                        commentable_type: tipo di commento (help request),
                        commentable_id: id della richiesta da commentare,
   * @returns aggiunge un nuovo commento
   */
  addComment(newComment: any): Observable<any> {
    return of({ result: newComment });
  }

  /**
                         *
                         * @param comment     id: id del commento da modificare,
                                              description: nuovo contenuto del commento
                         * @returns modifica un commento scritto dall'utente loggato
                         */
  editComment(comment_id: number, comment: any): Observable<any> {
    return of({ result: comment });
  }

  /**
   *
   * @param comment_id id del commento da eliminare
   * @returns elimina un commento scritto dall'utente loggato
   */
  destroyComment(comment_id: any): Observable<any> {
    return of({ result: null });
  }

  changeStatus(id: number, status: string): Observable<any> {
    return of({ result: { status } });
  }
}
